import { Accordion, Button, Flex, ScrollArea, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useAppDispatch } from "../../../../../hooks";
import { getProjectIdFromUrl } from "../../../../utils";
import { useCreateIssueMutation } from "../../issueRTKLegacy";
import { selectGroupedIssuesOnBoardByCategory, selectHttpIssuesOnBoard, selectIssueBoard } from "../../issueSelectors";
import { setTaskAndOrIssueArgsInRedux } from "../../issueSlice";
import { KanbanCardSJA } from "../Kanban/KanbanCardSJA/KanbanCardSJA";
import { KanbanCardSJADetail } from "../Kanban/KanbanCardSJA/KanbanCardSJADetails";

const IssueMobileViewSJA: React.FC = () => {
  const [openIssueId, setOpenIssueId] = useState<string | null>(null);

  const history = useHistory();
  const dispatch = useAppDispatch();
  const projectId = getProjectIdFromUrl(history.location.pathname);
  const issueBoard = useSelector(selectIssueBoard);
  const issues = useSelector(selectHttpIssuesOnBoard);
  const groupedIssues = useSelector(selectGroupedIssuesOnBoardByCategory);

  useEffect(() => {
    dispatch(setTaskAndOrIssueArgsInRedux(["TASK"]));
  }, []);

  const [createIssue] = useCreateIssueMutation();

  const LOCALSTORAGE_KEY = "issueMobileAccordionOpen";
  const [openAccordions, setOpenAccordions] = useState<string[]>(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem(LOCALSTORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    }
    return [];
  });

  if (!issues?.length) {
    return (
      <Flex justify="center" align="center" h="100%" p="md">
        <Text c="dimmed" fw={500}>
          No issues found
        </Text>
      </Flex>
    );
  }

  const openIssue = issues.find((issue) => issue._id === openIssueId);

  if (openIssue) {
    return <KanbanCardSJADetail content={openIssue} onClose={() => setOpenIssueId(null)} />;
  }

  return (
    <>
      <ScrollArea
        h="100%"
        type="auto"
        scrollbarSize={6}
        offsetScrollbars
        styles={{
          viewport: {
            paddingLeft: 8,
            paddingTop: 8,
            paddingRight: 8,
          },
        }}
      >
        <Accordion
          multiple
          variant="default"
          value={openAccordions}
          onChange={(values) => {
            setOpenAccordions(values as string[]);
            localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(values));
          }}
        >
          {Object.values(groupedIssues).map(({ id, title, items }) => (
            <Accordion.Item key={id} value={id}>
              <Accordion.Control>
                <Flex align="center" w="100%" justify="space-between" pr="xs">
                  <Text fw={600}>{title}</Text>

                  <Button
                    size="sm"
                    variant="primary"
                    style={{
                      minWidth: 90,
                      opacity: openAccordions.includes(id) ? 1 : 0.5,
                      pointerEvents: openAccordions.includes(id) ? "auto" : "none",
                    }}
                    onClick={async (e) => {
                      e.stopPropagation();

                      const newTask = await createIssue({
                        projectId,
                        issueBoardId: issueBoard?._id,
                        issueIdIfItIsATask: id,
                        taskOrIssue: "TASK",
                        issueTitle: "Ny risiko",
                      }).unwrap();

                      setOpenIssueId(newTask._id);
                    }}
                  >
                    Legg til
                  </Button>
                </Flex>
              </Accordion.Control>

              <Accordion.Panel>
                <Flex wrap="wrap" justify="center" align="start" gap="xs">
                  {items.map((task) => (
                    <KanbanCardSJA key={task._id} content={task} onOpen={() => setOpenIssueId(task._id)} isMobile />
                  ))}
                </Flex>
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      </ScrollArea>
    </>
  );
};

export default IssueMobileViewSJA;
